module.exports = __webpack_public_path__ + "img/step37_1_mfp_locate_refeed_preventers - Copy.1b8879a3.png";